import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './components/common/responsive.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { ThemeProvider } from './components/common/ThemeContext';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </BrowserRouter>
);

serviceWorkerRegistration.unregister();
